import axios from '../utils/axios';

class CategoryService {
  constructor() {
    this.BaseUrl = '/categories';
  }
  get() {
    return axios.get(this.BaseUrl);
  }

  delete(id) {
    return axios.delete(`${this.BaseUrl}/${id}`);
  }

  update(id, name) {
    return axios.put(`${this.BaseUrl}/${id}`, { name });
  }

  add(name) {
    return axios.post(this.BaseUrl, { name });
  }
}

export default new CategoryService();
